import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/location/:identifier',
            name: 'village_location',
            component: () => import("./views/location.vue"),
            meta: {
            }
        },
        {
            path: '/village/locationList',
            name: 'village_locationList',
            component: () => import("./views/locationList.vue"),
            meta: {
                hasBar: true,
            }
        },
    ];
};